import { updatePromotionsAction } from './actions';
import { createReducer } from '@reduxjs/toolkit';

export const promotionsShownReducer = createReducer({}, builder =>
  builder.addCase(updatePromotionsAction, (state, { payload }) => {
    return { ...state, ...payload };
  })
);
